import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const { sendOTP, verifyOTP, resetPassword } = useAuth();
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // TIMER STATES
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);

  // TIMER EFFECT
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleSendOTP = async () => {
    if (mobile.length !== 10) return alert("Enter valid mobile number");

    try {
      setLoading(true);
      await sendOTP(mobile, "forgot");
      setOtpSent(true);

      setTimer(120);
      setCanResend(false);

      alert("OTP sent to your registered number");
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    try {
      setLoading(true);
      await verifyOTP(mobile, otp);
      setOtpVerified(true);
      alert("OTP verified");
    } catch (err) {
      console.log(err);
      alert("Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword)
      return alert("Passwords do not match");

    try {
      setLoading(true);
      await resetPassword(mobile, newPassword);
      alert("Password reset successful!");
      navigate("/login");
    } catch (err) {
      console.log(err);
      alert("Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="fp-page-bg">
    <div className="fp-card">

      <h2 className="fp-title">Forgot Password</h2>
      <p className="fp-subtitle">Reset your password securely</p>

      {/* STEP 1 — ENTER MOBILE */}
      {!otpSent && (
        <div className="mt-3">
          <label className="form-label fw-semibold">Registered Mobile Number</label>
          <input
            type="tel"
            className="form-control fp-input"
            maxLength="10"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter 10-digit mobile"
          />

          <button className="btn fp-btn w-100 mt-3" onClick={handleSendOTP}>
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        </div>
      )}

      {/* STEP 2 — ENTER OTP */}
      {otpSent && !otpVerified && (
        <div className="mt-3">
          <label className="form-label fw-semibold">Enter OTP</label>
          <input
            className="form-control fp-input"
            maxLength="6"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
          />

          <button className="btn fp-btn w-100 mt-3" onClick={handleVerifyOTP}>
            {loading ? "Verifying..." : "Verify OTP"}
          </button>

          <div className="text-center mt-2">
            {canResend ? (
              <button
                type="button"
                className="resend-btn"
                onClick={handleSendOTP}
              >
                Resend OTP
              </button>
            ) : (
              <p className="timer-text">
                Resend in {String(Math.floor(timer / 60)).padStart(2, "0")}:
                {String(timer % 60).padStart(2, "0")}
              </p>
            )}
          </div>
        </div>
      )}

      {/* STEP 3 — RESET PASSWORD */}
      {otpVerified && (
        <form onSubmit={handleResetPassword} className="mt-4">

          <label className="form-label fw-semibold">New Password</label>
          <input
            className="form-control fp-input"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            required
          />

          <label className="form-label fw-semibold mt-3">Confirm Password</label>
          <input
            className="form-control fp-input"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re-enter new password"
            required
          />

          <button className="btn fp-btn w-100 mt-4" type="submit">
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      )}
    </div>
  </div>
);

};

export default ForgotPassword;
